import { useQuery } from 'react-query';
import { service } from '../redux/api/axios';

const useHook = () => {
  return useQuery(['notification_settings'], async () => {
    const response = await service.get(`/notificationSettings`);
    return response.data;
  });
};

export default useHook;
